import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-email-input',
    templateUrl: './email-input.component.html',
})
export class EmailInputComponent implements OnInit, OnChanges {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Output() changeEvent = new EventEmitter<string>();

    subscription: Subscription;

    constructor() {
    }

    get formControl(): UntypedFormControl {
        if (this.parentFormGroup && this.parentFormControlName) {
            return this.parentFormGroup.controls[this.parentFormControlName] as UntypedFormControl;
        }
        return undefined;
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const formControl = this.formControl;
        if (formControl) {
            const validators = [
                Validators.maxLength(70),
                Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')];

            if (formControl.validator) {
                validators.push(formControl.validator);
            }
            formControl.setValidators(validators);
        }

        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = this.formControl.valueChanges
            .subscribe(value => {
                if (this.changeEvent) {
                    this.changeEvent.emit(value);
                }
            });
    }

}
